import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import LoginCredentials from '../views/LoginCredentials.vue'
import MFA from '../views/MFA.vue'
import Profile from '../views/Profile.vue'
import Page404 from '../views/Page404.vue'
import Page500 from '../views/Page500.vue'
import Forbidden from '..//views/PageNoPermission.vue'
import Reset from '../views/Reset.vue'
import Verify from '../views/Verify.vue'
import VerifyMicrosoft from '../views/VerifyMicrosoft.vue'
import { default as DiariesV2 } from '../views/Diaries/DiariesV2.vue'
import { default as Diaries } from '../views/Diaries/Diaries.vue'
import { default as OperatorCreate } from '../views/Diaries/Operator/Create.vue'

import { default as OperatorEdit } from '../views/Diaries/Operator/Edit.vue'

import { default as OperatorEditEquipamentos } from '../views/Diaries/Operator/Edit.vue'
import { default as OperatorEditMaoObra } from '../views/Diaries/Operator/Edit.vue'

import { default as SupervisorCreate } from '../views/Diaries/Supervisor/Create.vue'
import { default as SupervisorEdit } from '../views/Diaries/Supervisor/Edit.vue'

import { default as ERPLaborView } from '../views/Diaries/ERP/LaborView.vue'
import { default as ERPEquipmentView } from '../views/Diaries/ERP/EquipmentView.vue'
import Users from '../views/Super/Users/Users.vue'
import User from '../views/Super/Users/User.vue'
import Works from '../views/Super/Users/Works.vue'
import CreateUser from '../views/Super/Users/CreateUser.vue'
import Roles from '../views/Super/Roles/Roles.vue'
import Role from '../views/Super/Roles/Role.vue'
import CreateRole from '../views/Super/Roles/CreateRole.vue'
import AddMaterial from '../views/Materials/AddMaterial.vue'
import Materials from '../views/Materials/Materials_version2.vue'
import Unities from '../views/Unities/Unities.vue'
import SubEmpreitadas from '../views/SubEmpreitadas/Subempreitadas.vue'
import Dashboard from '../views/Dashboard/Dashboard.vue'
import Logs from '../views/Logs/Logger.vue'

import ODCMachines from '../views/ODCMachines/ODCMachines.vue'
import CreateODCMachine from '../views/ODCMachines/CreateODCMachine.vue'

import ExternalCommunications from '../views/External/ExternalCommunications.vue'

import WorksSchedule from '../views/WorksSchedule/WorksSchedule.vue'
import CreateWorksSchedule from '../views/WorksSchedule/CreateWorksSchedule.vue'

import WorkerCards from '../views/WorkerCard/WorkerCards.vue'
import CreateWorkerCards from '../views/WorkerCard/CreateWorkerCards.vue'

import Templates from '../views/Templates/Templates.vue'
import CreateTemplates from '../views/Templates/CreateTemplatesV2.vue'
import EditTemplates from '../views/Templates/UpdateTemplates.vue'

import WorksConsult from '../views/Works/Consult.vue'

import Exports from '../views/Exports/Exports.vue'

import GuaranteesWorks from '../views/Guarantees/GuaranteesWorks.vue'
import CreateGuarantee from '../views/Guarantees/CreateGuarantee.vue'
import UpdateGuarantee from '../views/Guarantees/UpdateGuarantee.vue'

import CreateOperatorDiary from '@/views/Diaries/Operator/CreateDiary.vue'
import UpdateOperatorDiary from '@/views/Diaries/Operator/UpdateDiary.vue'

import CreateSupervisorDiary from "@/views/Diaries/Supervisor/CreateDiarySupervisor.vue"
import UpdateSupervisorDiary from "@/views/Diaries/Supervisor/UpdateSupervisorDiary.vue"

import Import_Garantias from "@/views/Imports/Import_Garantias.vue"

import ClientsODC from "@/views/ClientsODC/ClientsODC.vue"

import KPIS from '@/views/KPI/KPIS.vue'
import UpdateKPI from '@/views/KPI/UpdateKPI.vue'
import Seework from '@/views/Works/SeeWork.vue'

import Categorias from '@//views/Categorias/Categorias.vue'
import Atividades from '@//views/Atividades/Atividades.vue'

import Work_WorkUnits from '@/views/KPI/Work_WorkUnits.vue'

import Create_Work_WorkUnit from '@/views/KPI/Create_Work_WorkUnit.vue'
import Update_Work_WorkUnit from '@/views/KPI/Update_Work_WorkUnit.vue'

import CreateDiaryKPI from '@/views/Diaries/Kpi/CreateDiaryKPI.vue'
import UpdateDiaryKPI from '@/views/Diaries/Kpi/UpdateDiaryKPI.vue'
import DiariesKPI from '@/views/Diaries/Kpi/DiariesKPI.vue'

import DiariesKPIAggregator from '@/views/Diaries/Kpi/DiariesKPIAggregator.vue'

import DiariesAggregator from '@/views/Diaries/Aggregator/DiariesAggregator.vue'
import UpdateDiariesAggregator from '@/views/Diaries/Aggregator/UpdateDiariesAggregator.vue'

import UpdateDiaryKPIAggregator from '@/views/Diaries/Kpi/UpdateDiaryKPIAggregator.vue'

import Teams from '@/views/Teams/Teams.vue'
import CreateTeam from '@/views/Teams/CreateTeam.vue'
import UpdateTeam from '@/views/Teams/UpdateTeam.vue'

import Articulados from '@/views/Articulados/Articulados.vue'
import UpdateArticulado from '@/views/Articulados/UpdateArticulado.vue'

import Preventivas from '@/views/Preventivas/Preventivas.vue'

import CreateFaturas from '@/views/Faturas/CreateFaturas.vue'

import Colaboradores from '@/views/Colaboradores/Colaboradores.vue'

import Despesas from '@/views/Despesas/Despesas.vue'
import CreateDespesas from '@/views/Despesas/CreateDespesas.vue'
import UpdateDespesas from '@/views/Despesas/UpdateDespesas.vue'

import HallOfFame from '@/views/HallOfFame.vue'
import HowToDo from '@/views/HowToDo.vue'
import System from '@/views/system/System.vue'

import Suppliers from '@/views/suppliers/Suppliers.vue'
import UpdateSupplier from '@/views/suppliers/UpdateSupplier.vue'

import Evaluations from '@/views/supplier_evaluation/Evaluations.vue'
import UpdateEvaluation from '@/views/supplier_evaluation/UpdateEvaluation.vue'
import CreateEvaluation from '@/views/supplier_evaluation/CreateEvaluation.vue'

import Epis from '@/views/Epis/Epis.vue'

import SectionDiaries from '@/views/SectionDiaries/SectionDiaries.vue'
import CreateSectionDiary from '@/views/SectionDiaries/CreateSectionDiary.vue'
import UpdateSectionDiary from '@/views/SectionDiaries/UpdateSectionDiary.vue'

import Formacoes from '@/views/Formacoes/Formacoes.vue'
import UpdateFormacoes from '@/views/Formacoes/UpdateFormacoes.vue'
import CreateFormacoes from '@/views/Formacoes/CreateFormacoes.vue'

import Formularios from '@/views/Formacoes/Formularios/Formularios.vue'
import CreateFormulario from '@/views/Formacoes/Formularios/CreateFormulario.vue'
import UpdateFormulario from '@/views/Formacoes/Formularios/UpdateFormulario.vue'

import OrdensTrabalho from '@/views/OrdensTrabalho/OrdensTrabalho.vue'
import UpdateOrdensTrabalho from '@/views/OrdensTrabalho/UpdateOrdensTrabalho.vue'
import CreateOrdensTrabalho from '@/views/OrdensTrabalho/CreateOrdensTrabalho.vue'

import keycloak from '@/keycloak'


Vue.use(VueRouter)


const routes = [
  {
    path: '/ordens-trabalho/create',
    name: 'Formacoes',
    component: CreateOrdensTrabalho
  },
  {
    path: '/ordens-trabalho/:id',
    name: 'Formacoes',
    component: UpdateOrdensTrabalho
  },
  {
    path: '/ordens-trabalho',
    name: 'Formacoes',
    component: OrdensTrabalho
  },

  /*
   * =========================================================
   * FORMAÇÕES
   * =========================================================
   */

  {
    path: '/trainings/create',
    name: 'Criar Formação',
    component: CreateFormacoes
  },

  /*
   * IMPORTANTE:
   * As rotas de /trainings/forms têm de aparecer
   * ANTES de /trainings/:id.
   */

  {
    path: '/trainings/forms/create',
    name: 'Criar Formulário',
    component: CreateFormulario
  },
  {
    path: '/trainings/forms/:id',
    name: 'Editar Formulário',
    component: UpdateFormulario
  },
  {
    path: '/trainings/forms',
    name: 'Formulários',
    component: Formularios
  },

  {
    path: '/trainings/:id',
    name: 'Editar Formação',
    component: UpdateFormacoes
  },
  {
    path: '/trainings',
    name: 'Formações',
    component: Formacoes
  },

  /*
   * =========================================================
   * RESTO
   * =========================================================
   */

  {
    path: '/section-diaries/create',
    name: 'Diários de Secção',
    component: CreateSectionDiary
  },
  {
    path: '/section-diaries/:id',
    name: 'Diários de Secção',
    component: UpdateSectionDiary
  },
  {
    path: '/section-diaries',
    name: 'Diários de Secção',
    component: SectionDiaries
  },
  {
    path: '/evaluations/create',
    name: 'Criar avaliações',
    component: CreateEvaluation
  },
  {
    path: '/evaluations/:id',
    name: 'Atualizar avaliações',
    component: UpdateEvaluation
  },
  {
    path: '/evaluations/create/:supplier_id',
    name: 'Criar avaliações',
    component: CreateEvaluation
  },
  {
    path: '/evaluations',
    name: 'Avaliações',
    component: Evaluations
  },
  {
    path: '/suppliers/:id',
    name: 'UpdateSupplier',
    component: UpdateSupplier
  },
  {
    path: '/suppliers',
    name: 'Fornecedores',
    component: Suppliers
  },
  {
    path: '/faturas',
    name: 'Faturas',
    component: CreateFaturas
  },
  {
    path: '/preventivas',
    name: 'Preventivas',
    component: Preventivas
  },
  {
    path: '/kpi/articulados/:id',
    name: 'UpdateArticulado',
    component: UpdateArticulado
  },
  {
    path: '/kpi/articulados',
    name: 'Articulados',
    component: Articulados
  },
  {
    path: '/garantias/clients',
    name: 'Clientes',
    component: ClientsODC
  },
  {
    path: '/imports',
    name: 'Importações',
    component: Import_Garantias
  },
  {
    path: '/diarios/manobrador/registar',
    name: 'Registo Diário Manobrador',
    component: CreateOperatorDiary
  },
  {
    path: '/diarios/manobrador/:hash/:id_user/:type',
    name: 'Registo Diário Manobrador User type',
    component: UpdateOperatorDiary
  },
  {
    path: '/garantias/obras',
    name: 'Consultar obras',
    component: GuaranteesWorks
  },
  {
    path: '/garantias/obras/create',
    name: 'Criar obras',
    component: CreateGuarantee
  },
  {
    path: '/garantias/obras/:id',
    name: 'Atualizar obras',
    component: UpdateGuarantee
  },
  {
    path: '/super/logs',
    name: 'Logs',
    component: Logs
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/despesas',
    name: 'Despesas',
    component: Despesas
  },
  {
    path: '/despesas/create',
    name: 'CreateDespesas',
    component: CreateDespesas
  },
  {
    path: '/despesas/:id',
    name: 'UpdateDespesas',
    component: UpdateDespesas
  },
  {
    path: '/configuracoes/criar/materiais',
    name: 'Registo Novo Material',
    component: AddMaterial
  },
  {
    path: '/configuracoes/editar/materiais/:id',
    name: 'Editar Material',
    component: AddMaterial
  },
  {
    path: '/configuracoes/materiais',
    name: 'Consultar registo material',
    component: Materials
  },
  {
    path: '/',
    redirect: '/dashboard'
  },

  /*
   * Rotas antigas de autenticação.
   *
   * Mantemos as rotas para não partir links antigos,
   * mas um utilizador autenticado no Keycloak será
   * enviado para o Dashboard pelo beforeEach.
   */
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'login-credentials',
    path: '/logincred',
    component: LoginCredentials
  },
  {
    name: 'mfa',
    path: '/mfa',
    component: MFA
  },

  {
    path: '/perfil',
    name: 'Perfil',
    component: Profile
  },
  {
    path: '/works_consult/colaboradores/:id',
    name: 'Colaboradores',
    component: Colaboradores
  },
  {
    path: '/perfil/microsoft',
    name: 'Perfil_Microsoft',
    component: Profile
  },
  {
    path: '/diarios',
    name: 'Diários',
    component: Diaries
  },
  {
    path: '/diarios/v2',
    name: 'Diários V2',
    component: DiariesV2
  },
  {
    path: '/configuracoes/unities',
    name: 'Registo Unidades',
    component: Unities
  },
  {
    path: '/configuracoes/subempreitadas',
    name: 'Gerir subempreitadas',
    component: SubEmpreitadas
  },
  {
    path: '/kpi/registar',
    name: 'Registo Diário KPI',
    component: CreateDiaryKPI
  },
  {
    path: '/kpi/edit/aggregator/:id',
    name: 'Edição Diária KPI',
    component: UpdateDiaryKPIAggregator
  },
  {
    path: '/kpi/edit/:id',
    name: 'Edição Diário KPI',
    component: UpdateDiaryKPI
  },
  {
    path: '/kpi/lista-de-diarios',
    name: 'Edição Diário KPI lista',
    component: DiariesKPI
  },
  {
    path: '/kpi/lista-de-diarios-dia',
    name: 'Edição Diário KPI lista',
    component: DiariesKPIAggregator
  },
  {
    path: '/diarios/dia',
    name: 'Diárias por dia',
    component: DiariesAggregator
  },
  {
    path: '/diarios/dia/:day/:work_id',
    name: 'Edição Diário Dia',
    component: UpdateDiariesAggregator
  },
  {
    path: '/diarios/encarregado/registar',
    name: 'Registo Diário Encarregado',
    component: CreateSupervisorDiary
  },
  {
    path: '/diarios/encarregado/editar/:hash/:id_user',
    name: 'Registo Diário Encarregado Hash',
    component: UpdateSupervisorDiary
  },
  {
    path: '/diarios/view/erp/equipment/:id',
    name: 'Registo Diário Equipamentos - ERP',
    component: ERPEquipmentView
  },
  {
    path: '/diarios/view/erp/labor/:id',
    name: 'Registo Diário Mão Obra - ERP',
    component: ERPLaborView
  },
  {
    path: '/super/utilizadores',
    name: 'Consultar Utilizadores',
    component: Users
  },
  {
    path: '/super/utilizadores/registar',
    name: 'Registo Utilizador',
    component: CreateUser
  },
  {
    path: '/super/utilizadores/:id',
    name: 'Consultar Utilizador',
    component: User
  },
  {
    path: '/super/utilizadores/:id/epis',
    name: 'Consultar EPIS Utilizador',
    component: User
  },
  {
    path: '/super/utilizadores/:id/obras',
    name: 'Gerir Obras',
    component: Works
  },
  {
    path: '/super/roles',
    name: 'Consultar Roles',
    component: Roles
  },
  {
    path: '/super/roles/registar',
    name: 'Registo Role',
    component: CreateRole
  },
  {
    path: '/super/roles/:id',
    name: 'Consultar Role',
    component: Role
  },
  {
    path: '/frota/odc_machines',
    name: 'Consultar máquinas',
    component: ODCMachines
  },
  {
    path: '/frota/works_schedule',
    name: 'Consultar obras Schedule',
    component: WorksSchedule
  },
  {
    path: '/frota/works_schedule/registar',
    name: 'Registar horário de obras',
    component: CreateWorksSchedule
  },
  {
    path: '/frota/works_schedule/editar/:id',
    name: 'Atualizar horário de obra',
    component: CreateWorksSchedule
  },
  {
    path: '/frota/worker_card',
    name: 'Consultar cartões de utilizador',
    component: WorkerCards
  },
  {
    path: '/frota/worker_card/registar',
    name: 'Registar cartões de utilizador',
    component: CreateWorkerCards
  },
  {
    path: '/frota/worker_card/editar/:id',
    name: 'Atualizar cartões de utilizador',
    component: CreateWorkerCards
  },
  {
    path: '/frota/odc_machines/registar',
    name: 'Registar máquina',
    component: CreateODCMachine
  },
  {
    path: '/frota/odc_machines/editar/:id',
    name: 'Atualizar máquina',
    component: CreateODCMachine
  },
  {
    path: '/frota/external_communications',
    name: 'Comunicações externas',
    component: ExternalCommunications
  },
  {
    path: '/configuracoes/templates/registar',
    name: 'Registar template',
    component: CreateTemplates
  },
  {
    path: '/configuracoes/templates/editar/:id',
    name: 'Atualizar template',
    component: EditTemplates
  },
  {
    path: '/configuracoes/templates',
    name: 'Templates',
    component: Templates
  },
  {
    path: '/works_consult',
    name: 'Consulta de Obras',
    component: WorksConsult
  },
  {
    path: '/exports',
    name: 'Exportações',
    component: Exports
  },
  {
    path: '/howtodo',
    name: 'Como Fazer',
    component: HowToDo
  },
  {
    name: 'reset',
    path: '/reset/:id/:hash',
    component: Reset
  },
  {
    name: 'verify_microsoft',
    path: '/verify-email-microsoft',
    component: VerifyMicrosoft
  },
  {
    name: 'verify',
    path: '/verify-email/:id/:hash',
    component: Verify
  },
  {
    name: 'KPIS_articulado',
    path: '/kpi/list',
    component: KPIS
  },
  {
    name: 'KPIS_articulado ID',
    path: '/kpi/list/articulado/:id',
    component: UpdateKPI
  },
  {
    name: 'Categorias',
    path: '/kpi/categories',
    component: Categorias
  },
  {
    name: 'Atividades',
    path: '/kpi/activities',
    component: Atividades
  },
  {
    path: '/kpi/work_work_units',
    component: Work_WorkUnits
  },
  {
    path: '/kpi/work_work_units/create',
    component: Create_Work_WorkUnit
  },
  {
    path: '/kpi/work_work_units/:id',
    component: Update_Work_WorkUnit
  },
  {
    name: 'SeeWork',
    path: '/works_consult/kpi-config/:id',
    component: Seework
  },
  {
    name: 'Teams',
    path: '/configuracoes/equipas',
    component: Teams
  },
  {
    path: '/configuracoes/equipas/create',
    component: CreateTeam
  },
  {
    path: '/configuracoes/equipas/:id',
    component: UpdateTeam
  },
  {
    name: 'Config. do Sistema',
    path: '/system-settings',
    component: System
  },
  {
    name: 'EPIs',
    path: '/epis',
    component: Epis
  },
  {
    name: 'forbidden',
    path: '/forbidden',
    component: Forbidden
  },
  {
    name: 'page500',
    path: '/500',
    component: Page500
  },
  {
    name: 'page404',
    path: '*',
    component: Page404
  }

  // {
  //   name: 'HallOfFame',
  //   path: '/hallOfFame',
  //   component: HallOfFame
  // }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


/*
 * =========================================================
 * KEYCLOAK ROUTER GUARD
 * =========================================================
 *
 * A autenticação já NÃO depende de:
 *
 * localStorage.getItem('auth')
 *
 * A fonte de verdade passa a ser o Keycloak.
 *
 * O main.js inicializa o Keycloak ANTES de montar o Vue,
 * portanto quando este guard é executado já sabemos se
 * existe uma sessão válida.
 */
router.beforeEach((to, from, next) => {
  const isAuthenticated =
    keycloak.authenticated === true


  /*
   * Estas rotas podem continuar acessíveis sem depender
   * do login antigo da aplicação.
   *
   * Nota:
   * com onLoad: 'login-required' no main.js, na prática
   * o Keycloak autentica o utilizador antes de o Vue
   * arrancar.
   */
  const publicRouteNames = new Set([
    'reset',
    'verify',
    'verify_microsoft',
    'forbidden',
    'page500',
    'page404'
  ])


  /*
   * O login antigo do ODC deixa de ser utilizado.
   *
   * Se algum link ou código antigo tentar mandar o
   * utilizador para /login, enviamos para o Dashboard
   * quando já existe sessão Keycloak.
   */
  if (
    isAuthenticated &&
    (
      to.name === 'login' ||
      to.name === 'login-credentials' ||
      to.name === 'mfa'
    )
  ) {
    next({
      name: 'Dashboard'
    })

    return
  }


  const isPublicRoute =
    publicRouteNames.has(to.name)


  /*
   * Se por algum motivo chegarmos aqui sem sessão
   * Keycloak, não fazemos login através das páginas
   * antigas do ODC.
   *
   * Mandamos diretamente para o Keycloak.
   */
  if (
    !isAuthenticated &&
    !isPublicRoute
  ) {
    keycloak.login({
      redirectUri: window.location.href
    })

    return
  }


  next()
})


export default router